import {
	CREATE_CATEGORY_REQUEST,
	CREATE_CATEGORY_SUCCESS,
	CREATE_CATEGORY_FAIL,
	FETCH_CATEGORIES_REQUEST,
	FETCH_CATEGORIES_SUCCESS,
	FETCH_CATEGORIES_FAIL,
	UPDATE_CATEGORY_REQUEST,
	UPDATE_CATEGORY_SUCCESS,
	UPDATE_CATEGORY_FAIL,
	DELETE_CATEGORY_REQUEST,
	DELETE_CATEGORY_SUCCESS,
	DELETE_CATEGORY_FAIL,
	FETCH_CATEGORY_REQUEST,
	FETCH_CATEGORY_SUCCESS,
	FETCH_CATEGORY_FAIL,
} from "../constants/category";

function createCategoryReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case CREATE_CATEGORY_REQUEST:
			return { loading: true };
		case CREATE_CATEGORY_SUCCESS:
			return { loading: false, success: true, category: action.payload };
		case CREATE_CATEGORY_FAIL:
			return { loading: false, success: false, error: action.payload };
		default:
			return state;
	}
}

function fetchCategoriesReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			categoryUpdated: false,
			error: null,
			categoryDeleted: false,
		};
	}
	switch (action.type) {
		case FETCH_CATEGORIES_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_CATEGORIES_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				categories: action.payload,
			};
		case FETCH_CATEGORIES_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateCategoryReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", error: null, categoryUpdated: false };
	}
	switch (action.type) {
		case UPDATE_CATEGORY_REQUEST:
			return { loading: true };
		case UPDATE_CATEGORY_SUCCESS:
			return {
				...state,
				loading: false,
				categoryUpdated: true,
			};
		case UPDATE_CATEGORY_FAIL:
			return { loading: false, categoryUpdated: false, error: action.payload };
		default:
			return state;
	}
}

function deleteCategoryReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case DELETE_CATEGORY_REQUEST:
			return { loading: true };
		case DELETE_CATEGORY_SUCCESS:
			return {
				loading: false,
				categoryDeleted: true,
			};
		case DELETE_CATEGORY_FAIL:
			return { loading: false, categoryDeleted: false, error: action.payload };
		default:
			return state;
	}
}

function fetchCategoryReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
			categoryUpdated: false,
			categoryDeleted: false,
		};
	}

	switch (action.type) {
		case FETCH_CATEGORY_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_CATEGORY_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				category: action.payload,
			};
		case FETCH_CATEGORY_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

export {
	createCategoryReducer,
	fetchCategoriesReducer,
	updateCategoryReducer,
	deleteCategoryReducer,
	fetchCategoryReducer,
};
